<!-- <mat-spinner *ngIf="loadingService.isLoading | async " class="page-spinner"></mat-spinner> -->
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#d4cccc"
  type="ball-climbing-dot"
  [fullScreen]="true"
>
  <p style="color: white">Loading...</p>
</ngx-spinner>
<app-toolbar>

</app-toolbar>

<!-- <div [ngClass]="{'page-blur': loadingService.isLoading | async}" class="page-spinner-container page-overlay">
  <mat-spinner *ngIf="loadingService.isLoading | async" class="page-spinner"></mat-spinner>
</div> -->